import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/client";

// 🎰 Fetch Casino Profit/Loss
export const fetchCasinoResults = createAsyncThunk(
  "profitLoss/fetchCasinoResults",
  async ({ userId}, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/casino/total-pl`, {
        params: { userId },
      });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch casino results" });
    }
  }
);

// 🏏 Fetch Cricket Profit/Loss
export const fetchCricketResults = createAsyncThunk(
  "profitLoss/fetchCricketResults",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/cricket/match-pl`, { params: { userId } });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch cricket results" });
    }
  }
);

//  Fetch All Profit/Loss
export const fetchAllResults = createAsyncThunk(
  "profitLoss/fetchAllResults",
  async (userId, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/all/pl`, { params: { userId } });
      return res.data;

    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch all results" });
    }
  }
);


// Fetch All Odss PL
export const fetchOddsPL = createAsyncThunk(
  "profitLoss/fetchOddsPL",
  async ({ userId, matchId }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/match/bets/odds/${userId}/${matchId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch" });
    }
  }
);

// Fetch All Odss PL
export const fetchbookPL = createAsyncThunk(
  "profitLoss/fetchbookPL",
  async ({ userId, matchId }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/match/bets/bookm/${userId}/${matchId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch" });
    }
  }
);

// Fetch fancy PL
export const fetchfacnyPL = createAsyncThunk(
  "profitLoss/fetchfacnyPL",
  async ({ userId, matchId }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/match/bets/fancy/${userId}/${matchId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch" });
    }
  }
);

// Fetch Tie PL
export const fetchTiePL = createAsyncThunk(
  "profitLoss/fetchTiePL",
  async ({ userId, matchId }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/match/bets/tie/${userId}/${matchId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch" });
    }
  }
);


// Fetch toss PL
export const fetchTossPL = createAsyncThunk(
  "profitLoss/fetchTossPL",
  async ({ userId, matchId }, { rejectWithValue }) => {
    try {
      const res = await api.get(`/user-history/match/bets/toss/${userId}/${matchId}`);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || { message: "Failed to fetch" });
    }
  }
);




const profitLossSlice = createSlice({
  name: "profitLoss",
  initialState: {
    allResults: { cricket: [], casino: [] },
    totalCountAll : [],
    casinoResults: [],
    totalCountCasino: 0,
    cricketResults: [],
     OddsPL:[],
     bookPL:[],
     TossPL:[],
     TiePL:[],
     facnyPL:[],
    totalCountCricket: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    // Casino
    builder
      .addCase(fetchCasinoResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCasinoResults.fulfilled, (state, action) => {
        state.loading = false;
        state.casinoResults = action.payload.data || [];
        state.totalCountCasino = action.payload.totalCount || 0;
      })
      .addCase(fetchCasinoResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching casino results";
      });

    // Cricket
    builder
      .addCase(fetchCricketResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCricketResults.fulfilled, (state, action) => {
        state.loading = false;
        state.cricketResults = action.payload.data || [];
        state.totalCountCricket = action.payload.totalCount || 0;
      })
      .addCase(fetchCricketResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching cricket results";
      })

  
      .addCase(fetchAllResults.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllResults.fulfilled, (state, action) => {
        state.loading = false;
        state.allResults = action.payload;
        state.totalCountAll = action.payload.totalCount || 0;
      })
      .addCase(fetchAllResults.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching results";
      })
      ///fecth odds PL

      .addCase(fetchOddsPL.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
    .addCase(fetchOddsPL.fulfilled, (state, action) => {
    state.loading = false;
    state.OddsPL = action.payload || []; 
})
      .addCase(fetchOddsPL.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching results";
      })

       ///fecth book PL

      .addCase(fetchbookPL.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchbookPL.fulfilled, (state, action) => {
        state.loading = false;
        state.allResults = action.payload;
        state.bookPL = action.payload || []; 
      })
      .addCase(fetchbookPL.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching results";
      })

       ///fecth fancy PL

       .addCase(fetchfacnyPL.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
       .addCase(fetchfacnyPL.fulfilled, (state, action) => {
        state.loading = false;
        state.allResults = action.payload;
        state.facnyPL = action.payload || []; 
      })
       .addCase(fetchfacnyPL.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching results";
      })

      
       ///fecth Tie PL

       .addCase(fetchTiePL.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
       .addCase(fetchTiePL.fulfilled, (state, action) => {
        state.loading = false;
        state.allResults = action.payload;
        state.TiePL = action.payload || []; 
      })
       .addCase(fetchTiePL.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching results";
      })

      ///fecth toss PL

       .addCase(fetchTossPL.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
       .addCase(fetchTossPL.fulfilled, (state, action) => {
        state.loading = false;
        state.allResults = action.payload;
        state.TossPL = action.payload || []; 
      })
       .addCase(fetchTossPL.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Error fetching results";
      });

  },
});

export default profitLossSlice.reducer;
